import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";

import {
  AndroidOsIcon,
  AppleLogoIcon,
  AppleTvIcon,
  ChromeIcon,
  FirefoxIcon,
  InternetExplorerIcon,
  MicrosoftEdgeIcon,
  SafariIcon,
  SmartWatchIcon,
  WindowsXpIcon,
} from "../components/icons/themes/color";

const useStyles = makeStyles((theme) => ({
  valueIcon: {
    position: "relative",
    top: 1,
    marginRight: theme.spacing(0.5),
  },
}));

function keywordMapLookup(keywordToIconMap, lookup, iconProps) {
  for (let entry of keywordToIconMap) {
    for (let keyword of entry.keywords) {
      if (lookup.indexOf(keyword) !== -1) {
        const Icon = entry.icon;
        return <Icon {...iconProps} />;
      }
    }
  }

  return null;
}

const BrowserIcon = ({ browser }) => {
  browser = browser.toLowerCase();
  const styles = useStyles();
  const iconProps = {
    height: 14,
    width: 14,
    className: styles.valueIcon,
  };

  const keywordToIconMap = [
    { keywords: ["chrome"], icon: ChromeIcon },
    { keywords: ["safari"], icon: SafariIcon },
    { keywords: ["firefox"], icon: FirefoxIcon },
    { keywords: ["edge"], icon: MicrosoftEdgeIcon },
    { keywords: ["ie", "internet explorer"], icon: InternetExplorerIcon },
  ];

  return keywordMapLookup(keywordToIconMap, browser, iconProps);
};

BrowserIcon.propTypes = {
  browser: PropTypes.any,
};

const OSIcon = ({ os }) => {
  os = os.toLowerCase();
  const styles = useStyles();
  const iconProps = {
    height: 14,
    width: 14,
    className: styles.valueIcon,
  };

  const keywordToIconMap = [
    { keywords: ["mac os x", "ios"], icon: AppleLogoIcon },
    { keywords: ["android"], icon: AndroidOsIcon },
    { keywords: ["windows"], icon: WindowsXpIcon },
    { keywords: ["tv os", "tvos"], icon: AppleTvIcon },
    { keywords: ["watch os", "watchos"], icon: SmartWatchIcon },
  ];

  return keywordMapLookup(keywordToIconMap, os, iconProps);
};

OSIcon.propTypes = {
  os: PropTypes.any,
};

const ValueIcon = ({ name, value }) => {
  switch (name.toLowerCase()) {
    case "browser":
      return <BrowserIcon browser={value} />;
    case "operating_system":
      return <OSIcon os={value} />;
    default:
      return null;
  }
};

ValueIcon.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
};

export { ValueIcon, OSIcon, BrowserIcon };
